import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { translateErrors } from "../../../common/utils/translateErrors";
import { useTranslation } from "../../../i18n/useTranslation";
import { Errors } from "../Styles";
export const ErrorMessages = ({ type, message }) => {
    const { t } = useTranslation();
    const { [type]: ErrorNode } = {
        card: CardErrors,
        alipay: AlipayErrors,
        apple_pay: Errors,
    };
    return _jsx(ErrorNode, { children: translateErrors(t, message) });
};
const CardErrors = styled(Errors) `
  margin: ${(p) => `${p.theme.spacing.sp24} 0 0`};
`;
const AlipayErrors = styled(Errors) `
  margin: ${(p) => `${p.theme.spacing.sp24} 0`};
`;
